import {
  faCalendarAlt,
  faClock,
  faMap,
  faHourglass,
  faQuestionCircle,
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-regular-svg-icons'
import { faLock, faUser, faCheck, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { AngularFireModule } from '@angular/fire'
import { AngularFireDatabaseModule } from 'angularfire2/database'
import { RouterModule } from '@angular/router'
import { PublicAppComponent } from './public-app.component'
import { environment } from './environments/environment'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http'
import { PublicAppRoutingModule } from './app.routing'
import { LoginPageComponent } from './components/login-page/login-page.component'
import { EventListComponent } from './components/event-list/event-list.component'
import { MyEventListComponent } from './components/my-event-list/my-event-list.component'
import { EventDetailsComponent } from './components/event-details/event-details.component'
import { DataReconciliationComponent } from './components/data-reconciliation/data-reconciliation.component'
import { PublicHeaderComponent } from './components/public-header/public-header.component'
import { EventListItemComponent } from './components/event-list-item/event-list-item.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component'
import { ToastComponent } from './components/toast/toast.component'
import { ProfilePageComponent } from './components/profile-page/profile-page.component'
import { UserDeletePopupComponent } from './components/user-delete-popup/user-delete-popup.component'
import { PublicFooterComponent } from './components/public-footer/public-footer.component'
import { RegisterPageComponent } from './components/register-page/register-page.component'
import { ForgottenPasswordComponent } from './components/forgotten-password/forgotten-password.component'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'
import { ScrollToTopComponent } from '@public/app/components/scroll-to-top/scroll-to-top.component'
import { EventRegisterButtonComponent } from './components/event-shared/event-register-button/event-register-button.component'
import { LoginReminderComponent } from './components/login-reminder/login-reminder.component'
import { EventFilterComponent } from '@public/app/components/event-filter/event-filter.component'

@NgModule({
  declarations: [
    PublicAppComponent,
    LoginPageComponent,
    EventListComponent,
    MyEventListComponent,
    EventDetailsComponent,
    DataReconciliationComponent,
    PublicHeaderComponent,
    EventListItemComponent,
    LoadingIndicatorComponent,
    ToastComponent,
    ProfilePageComponent,
    UserDeletePopupComponent,
    PublicFooterComponent,
    RegisterPageComponent,
    ForgottenPasswordComponent,
    ResetPasswordComponent,
    ScrollToTopComponent,
    EventRegisterButtonComponent,
    LoginReminderComponent,
    EventFilterComponent,
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    PublicAppRoutingModule,
    FontAwesomeModule,
  ],
  providers: [],
  bootstrap: [PublicAppComponent],
  exports: [EventFilterComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faCalendarAlt,
      faClock,
      faMap,
      faHourglass,
      faUser,
      faQuestionCircle,
      faCheckCircle,
      faTimesCircle,
      faLock,
      faEnvelope,
      faCheck
    )
  }
}
